export const hivHeroData = {
    title: "HIV/AIDS",
    subtitle: "Antiretroviral therapy and HIV management medications",
    stats: [
        { number: "30+ HIV Medications", label: "Medications" },
        { number: "Save up to 95%", label: "Our Price" },
        { number: "WHO-GMP Certified", label: "Certified" }
    ]
};

export const hivProducts = [
    {
        id: "tdf-ftc-truvada",
        name: "TDF/FTC (Truvada)",
        genericName: "Tenofovir Disoproxil/Emtricitabine",
        indication: "HIV Prevention & Treatment",
        originalPrice: "$2,200",
        price: "$540",
        savings: "75%",
        description: "Combination medicine used with other antiretroviral agents for the treatment of HIV-1 infection in adults and pediatric patients weighing at least 17 kg.",
        dosage: "Typically one tablet once daily, with or without food.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Gilead Sciences / Licensed Generic Manufacturers",
        storage: "Store at 25°C (77°F). Keep container tightly closed.",
        sideEffects: "Headache, dizziness, nausea, tiredness, and trouble sleeping.",
        category: "First Line"
    },
    {
        id: "dolutegravir-50mg",
        name: "Dolutegravir 50mg",
        genericName: "Dolutegravir Sodium",
        indication: "HIV Treatment",
        originalPrice: "$2,000",
        price: "$160",
        savings: "92%",
        description: "An integrase strand transfer inhibitor (INSTI) indicated in combination with other antiretroviral agents for the treatment of HIV-1 infection.",
        dosage: "50 mg once daily for most patients.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Viiv Healthcare / Licensed Generic Manufacturers",
        storage: "Store below 30°C in a dry place.",
        sideEffects: "Insomnia, headache, and fatigue.",
        category: "First Line"
    },
    {
        id: "efavirenz-600mg",
        name: "Efavirenz 600mg",
        genericName: "Efavirenz",
        indication: "HIV Treatment",
        originalPrice: "$1,500",
        price: "$35",
        savings: "97%",
        description: "A non-nucleoside reverse transcriptase inhibitor (NNRTI) used as part of highly active antiretroviral therapy (HAART) for the treatment of HIV-1.",
        dosage: "600 mg once daily on an empty stomach, preferably at bedtime.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Merck / Licensed Generic Manufacturers",
        storage: "Store at room temperature away from moisture.",
        sideEffects: "Dizziness, trouble sleeping, drowsiness, and unusual dreams.",
        category: "First Line"
    },
    {
        id: "rilpivirine-tdf-ftc",
        name: "Rilpivirine/TDF/FTC",
        genericName: "Complera / Eviplera Equivalent",
        indication: "HIV Treatment/Preventive",
        originalPrice: "$3,500",
        price: "$280",
        savings: "92%",
        description: "A complete three-drug regimen for the treatment of HIV-1 infection in certain patients.",
        dosage: "One tablet daily with a meal.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Gilead Sciences / Licensed Generic Manufacturers",
        storage: "Store between 15°C and 30°C.",
        sideEffects: "Nausea, dizziness, headache, and rash.",
        category: "Single Tablet Regimen"
    },
    {
        id: "darunavir-600mg",
        name: "Darunavir 600mg",
        genericName: "Prezista Equivalent",
        indication: "HIV Treatment/Preventive",
        originalPrice: "$2,400",
        price: "$280",
        savings: "88%",
        description: "A protease inhibitor used in combination with ritonavir and other medications to treat HIV-1 infection.",
        dosage: "Usually taken twice daily with ritonavir and food.",
        packaging: "Bottle of 60 Tablets",
        manufacturer: "Janssen / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Diarrhea, nausea, and headache.",
        category: "Protease Inhibitors"
    },
    {
        id: "ritonavir-100mg",
        name: "Ritonavir 100mg",
        genericName: "Norvir Equivalent",
        indication: "HIV Booster",
        originalPrice: "$600",
        price: "$50",
        savings: "91%",
        description: "Used as a 'pharmacokinetic enhancer' (booster) to increase the levels of other HIV protease inhibitors.",
        dosage: "Taken with other HIV medications and food.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "AbbVie / Licensed Generic Manufacturers",
        storage: "Store in refrigerator if possible, or below 25°C for 30 days.",
        sideEffects: "Nausea, vomiting, diarrhea, and tingling in hands/feet.",
        category: "Protease Inhibitors"
    },
    {
        id: "atazanavir-300mg",
        name: "Atazanavir 300mg",
        genericName: "Reyataz Equivalent",
        indication: "HIV Treatment/Preventive",
        originalPrice: "$1,800",
        price: "$120",
        savings: "93%",
        description: "A protease inhibitor used with other medications to treat HIV-1 infection.",
        dosage: "300 mg once daily with food and ritonavir.",
        packaging: "Bottle of 30 Capsules",
        manufacturer: "Bristol-Myers Squibb / Licensed Generic Manufacturers",
        storage: "Store at 25°C. Keep bottle tightly closed.",
        sideEffects: "Yellowing of the skin/eyes (jaundice), nausea, and headache.",
        category: "Protease Inhibitors"
    },
    {
        id: "lopinavir-ritonavir",
        name: "Lopinavir/Ritonavir",
        genericName: "Kaletra Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$2,000",
        price: "$180",
        savings: "91%",
        description: "A co-formulation of two protease inhibitors used in the treatment of HIV-1.",
        dosage: "Usually taken twice daily with or without food.",
        packaging: "Bottle of 120 Tablets",
        manufacturer: "AbbVie / Licensed Generic Manufacturers",
        storage: "Store at room temperature. Avoid excessive heat.",
        sideEffects: "Diarrhea, nausea, and vomiting.",
        category: "Protease Inhibitors"
    },
    {
        id: "raltegravir-400mg",
        name: "Raltegravir 400mg",
        genericName: "Isentress Equivalent",
        indication: "HIV Treatment/Preventive",
        originalPrice: "$2,000",
        price: "$170",
        savings: "91%",
        description: "An integrase inhibitor used with other antiretroviral agents for the treatment of HIV-1.",
        dosage: "400 mg twice daily with or without food.",
        packaging: "Bottle of 60 Tablets",
        manufacturer: "Merck / Licensed Generic Manufacturers",
        storage: "Store in original container at room temperature.",
        sideEffects: "Dizziness, headache, and nausea.",
        category: "Second Line"
    },
    {
        id: "abacavir-300mg",
        name: "Abacavir 300mg",
        genericName: "Ziagen Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$1,500",
        price: "$160",
        savings: "89%",
        description: "A nucleoside reverse transcriptase inhibitor (NRTI). Requires genetic testing (HLA-B*5701) before use.",
        dosage: "300 mg twice daily or 600 mg once daily.",
        packaging: "Bottle of 60 Tablets",
        manufacturer: "Viiv Healthcare / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Nausea, headache, and fatigue. Seek immediate help for rash/fever.",
        category: "First Line"
    },
    {
        id: "lamivudine-300mg",
        name: "Lamivudine 300mg",
        genericName: "Epivir Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$800",
        price: "$40",
        savings: "95%",
        description: "An NRTI used in combination with other medications for HIV and Hepatitis B treatment.",
        dosage: "300 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Viiv Healthcare / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Headache, nausea, and fatigue.",
        category: "First Line"
    },
    {
        id: "zidovudine-300mg",
        name: "Zidovudine 300mg",
        genericName: "Retrovir Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$800",
        price: "$40",
        savings: "95%",
        description: "One of the first HIV NRTIs. Used in combination and for preventing mother-to-child transmission.",
        dosage: "300 mg twice daily.",
        packaging: "Bottle of 60 Tablets",
        manufacturer: "GSK / Licensed Generic Manufacturers",
        storage: "Store between 15°C and 25°C.",
        sideEffects: "Nausea, headache, and low blood cell counts.",
        category: "First Line"
    },
    {
        id: "nevirapine-200mg",
        name: "Nevirapine 200mg",
        genericName: "Viramune Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$500",
        price: "$55",
        savings: "89%",
        description: "An NNRTI used as part of combination therapy. Requires careful dosing initiation.",
        dosage: "Initially 200 mg once daily for 14 days, then 200 mg twice daily.",
        packaging: "Bottle of 60 Tablets",
        manufacturer: "Boehringer Ingelheim / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Rash and liver toxicity.",
        category: "First Line"
    },
    {
        id: "rilpivirine-25mg",
        name: "Rilpivirine 25mg",
        genericName: "Edurant Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$1,400",
        price: "$90",
        savings: "93%",
        description: "An NNRTI used for treatment-naive patients with low viral loads.",
        dosage: "25 mg once daily with a high-calorie meal.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Janssen / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Depression, insomnia, and headache.",
        category: "First Line"
    },
    {
        id: "delavirdine-100mg",
        name: "Delavirdine 100mg",
        genericName: "Rescriptor Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$1,200",
        price: "$145",
        savings: "88%",
        description: "An NNRTI used in combination with other antiretrovirals.",
        dosage: "400 mg three times daily.",
        packaging: "Bottle of 180 Tablets",
        manufacturer: "Pfizer / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Rash, headache, and nausea.",
        category: "Second Line"
    },
    {
        id: "maraviroc-300mg",
        name: "Maraviroc 300mg",
        genericName: "Selzentry Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$2,050",
        price: "$180",
        savings: "91%",
        description: "A CCR5 antagonist. Requires a tropism test before initiation.",
        dosage: "300 mg twice daily depending on companion medications.",
        packaging: "Bottle of 60 Tablets",
        manufacturer: "Viiv Healthcare / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Cough, fever, and upper respiratory tract infections.",
        category: "Second Line"
    },
    {
        id: "enfuvirtide-90mg",
        name: "Enfuvirtide 90mg",
        genericName: "Fuzeon Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$3,200",
        price: "$210",
        savings: "93%",
        description: "A fusion inhibitor given by subcutaneous injection.",
        dosage: "90 mg (1 mL) twice daily as an injection.",
        packaging: "60 Vials per Month",
        manufacturer: "Roche / Licensed Generic Manufacturers",
        storage: "Store at room temperature. Once reconstituted, refrigerate.",
        sideEffects: "Injection site reactions, fatigue, and nausea.",
        category: "Salvage Therapy"
    },
    {
        id: "fostemsavir-600mg",
        name: "Fostemsavir 600mg",
        genericName: "Rukobia Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$4,500",
        price: "$250",
        savings: "94%",
        description: "An attachment inhibitor for heavily treatment-experienced patients.",
        dosage: "600 mg twice daily.",
        packaging: "Bottle of 60 Tablets",
        manufacturer: "Viiv Healthcare / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Nausea and liver enzyme elevation.",
        category: "Salvage Therapy"
    },
    {
        id: "ibalizumab-1.25g",
        name: "Ibalizumab 1.25g",
        genericName: "Trogarzo Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$9,000",
        price: "$550",
        savings: "94%",
        description: "A monoclonal antibody given by IV infusion every 14 days.",
        dosage: "2,000 mg loading dose, then 800 mg every 2 weeks.",
        packaging: "Two 200 mg/1.33 mL Vials",
        manufacturer: "Theratechnologies / Licensed Generic Manufacturers",
        storage: "Keep refrigerated (2°C to 8°C).",
        sideEffects: "Diarrhea, dizziness, and nausea.",
        category: "Salvage Therapy"
    },
    {
        id: "cabotegravir-30mg",
        name: "Cabotegravir 30mg",
        genericName: "Vocabria Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$3,000",
        price: "$195",
        savings: "93%",
        description: "Used as an oral lead-in before long-acting injectable therapy.",
        dosage: "30 mg once daily for 1 month.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Viiv Healthcare / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Headache, nausea, and fatigue.",
        category: "New Generation"
    },
    {
        id: "leronlimab",
        name: "Leronlimab",
        genericName: "PRO 140 Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$5,000",
        price: "$440",
        savings: "91%",
        description: "A CCR5 antagonist monoclonal antibody under clinical investigation.",
        dosage: "700 mg once weekly subcutaneous injection.",
        packaging: "One injection per week",
        manufacturer: "Licensed Biotech Manufacturers",
        storage: "Keep refrigerated.",
        sideEffects: "Injection site reactions.",
        category: "New Generation"
    },
    {
        id: "taf-ftc-descovy",
        name: "TAF/FTC (Descovy)",
        genericName: "Tenofovir Alafenamide/Emtricitabine",
        indication: "HIV Treatment",
        originalPrice: "$2,400",
        price: "$155",
        savings: "93%",
        description: "A newer version of Truvada with lower bone and kidney toxicity concerns.",
        dosage: "One tablet daily.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Gilead Sciences / Licensed Generic Manufacturers",
        storage: "Store below 30°C.",
        sideEffects: "Nausea, headache, and diarrhea.",
        category: "First Line"
    },
    {
        id: "dtg-3tc-dovato",
        name: "DTG/3TC (Dovato)",
        genericName: "Dolutegravir/Lamivudine",
        indication: "HIV Treatment",
        originalPrice: "$2,500",
        price: "$170",
        savings: "93%",
        description: "A complete two-drug regimen for HIV-1 infection.",
        dosage: "One tablet daily.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Viiv Healthcare / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Headache, nausea, and insomnia.",
        category: "Single Tablet Regimen"
    },
    {
        id: "dtg-abc-3tc-triumeq",
        name: "DTG/ABC/3TC (Triumeq)",
        genericName: "Dolutegravir/Abacavir/Lamivudine",
        indication: "HIV Treatment",
        originalPrice: "$3,200",
        price: "$210",
        savings: "93%",
        description: "A complete single-tablet three-drug regimen.",
        dosage: "One tablet daily.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Viiv Healthcare / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Insomnia, headache, and fatigue.",
        category: "Single Tablet Regimen"
    },
    {
        id: "efv-tdf-ftc-atripla",
        name: "EFV/TDF/FTC (Atripla)",
        genericName: "Efavirenz/Tenofovir/Emtricitabine",
        indication: "HIV Treatment",
        originalPrice: "$2,500",
        price: "$180",
        savings: "92%",
        description: "The first complete single-tablet regimen approved for HIV treatment.",
        dosage: "One tablet daily on an empty stomach.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Gilead / Merck / Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Dizziness, trouble sleeping, and unusual dreams.",
        category: "Single Tablet Regimen"
    },
    {
        id: "rpv-tdf-ftc-complera",
        name: "RPV/TDF/FTC (Complera)",
        genericName: "Rilpivirine/Tenofovir/Emtricitabine",
        indication: "HIV Treatment",
        originalPrice: "$3,400",
        price: "$220",
        savings: "93%",
        description: "A three-drug single-tablet regimen.",
        dosage: "One tablet daily with a meal.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Gilead / Janssen / Generic Manufacturers",
        storage: "Store below 30°C.",
        sideEffects: "Dizziness, headache, and insomnia.",
        category: "Single Tablet Regimen"
    },
    {
        id: "drv-c-taf-ftc-symtuza",
        name: "DRV/c/TAF/FTC (Symtuza)",
        genericName: "Darunavir/Cobicistat/TAF/FTC",
        indication: "HIV Treatment",
        originalPrice: "$4,200",
        price: "$270",
        savings: "93%",
        description: "The first protease inhibitor-based single-tablet regimen.",
        dosage: "One tablet daily with food.",
        packaging: "Bottle of 30 Tablets",
        manufacturer: "Janssen / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Diarrhea, nausea, and rash.",
        category: "Single Tablet Regimen"
    },
    {
        id: "etravirine-200mg",
        name: "Etravirine 200mg",
        genericName: "Intelence Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$2,100",
        price: "$135",
        savings: "93%",
        description: "An NNRTI used mainly for treatment-experienced patients.",
        dosage: "200 mg twice daily with food.",
        packaging: "Bottle of 60 Tablets",
        manufacturer: "Janssen / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Rash and nausea.",
        category: "Second Line"
    },
    {
        id: "tipranavir-250mg",
        name: "Tipranavir 250mg",
        genericName: "Aptivus Equivalent",
        indication: "HIV Treatment",
        originalPrice: "$2,400",
        price: "$155",
        savings: "93%",
        description: "A protease inhibitor for treatment-experienced patients.",
        dosage: "500 mg with 200 mg ritonavir twice daily.",
        packaging: "Bottle of 120 Capsules",
        manufacturer: "Boehringer Ingelheim / Generic Manufacturers",
        storage: "Store in refrigerator (2°C to 8°C).",
        sideEffects: "Liver toxicity and diarrhea.",
        category: "Salvage Therapy"
    }
];

export const hivCategories = [
    "All Categories",
    "First Line",
    "Second Line",
    "Protease Inhibitors",
    "Single Tablet Regimen",
    "Salvage Therapy",
    "New Generation"
];

export const hivTrustBadges = [
    { icon: "ShieldCheck", text: "100% Authentic ARVs" },
    { icon: "Plane", text: "Express Global Delivery" },
    { icon: "Award", text: "WHO-GMP Certified" }
];

export const hivFAQs = [
    {
        question: "How do you ensure the authenticity of HIV medications?",
        answer: "All our HIV medications (ARVs) are sourced directly from licensed, WHO-GMP certified pharmaceutical manufacturers in India. Every batch comes with a certificate of analysis and can be traced back to the manufacturer, ensuring 100% authenticity."
    },
    {
        question: "Is my privacy protected when ordering HIV treatment?",
        answer: "Yes, we prioritize your privacy. All orders are shipped in discreet packaging with no mention of the contents or the condition on the exterior. We use encrypted communication channels to handle all sensitive medical information."
    },
    {
        question: "Do I need a prescription to order these medications?",
        answer: "Yes, as a licensed pharmacy, we require a valid prescription from your healthcare provider. This ensures you are receiving the correct therapy for your specific medical needs."
    }
];

export const hivTestimonials = [
    {
        name: "Samuel O.",
        country: "Nigeria",
        savings: "$9,000+",
        condition: "HIV Managed",
        medication: "DTG/TAF/FTC Regimen",
        testimonial: "The cost of newer ARVs was impossible to maintain locally. MediSeller provided a reliable supply at a fraction of the cost. I've been stable for 4 years now thanks to their consistent service.",
        rating: 5
    },
    {
        name: "John D.",
        country: "USA",
        savings: "$15,000+",
        condition: "HIV+ since 2012",
        medication: "Biktarvy Equivalent",
        testimonial: "Switching to generic alternatives through MediSeller saved my financial life. Same lab results, same viral suppression, but thousands of dollars saved every month.",
        rating: 5
    }
];

export const hivSectionContent = {
    midPageCTA: {
        title: "Need a Specific ARV Combination?",
        description: "We can source almost any WHO-approved generic HIV medication or combination therapy. Our specialists can help you find affordable alternatives for your prescribed treatment.",
        whatsappText: "Chat with ARV Specialist",
        requestText: "Request Custom Quote"
    },
    testimonials: {
        title: "Community Success Stories",
        description: "Read how we've helped thousands of patients worldwide access affordable, life-saving HIV treatments."
    },
    faqs: {
        title: "HIV Treatment Support",
        description: "Common questions about sourcing and shipping antiretroviral medications globally."
    },
    finalCTA: {
        title: "Reliable Access to HIV Care",
        description: "Get consistent, affordable access to your prescribed antiretroviral therapy with secure global shipping and pharmacist support.",
        whatsappText: "Consult Our Pharmacist",
        requestText: "Upload Your Prescription"
    }
};
